import { render, staticRenderFns } from "./entry-add-classify.vue?vue&type=template&id=3d245f2a&scoped=true"
import script from "./entry-add-classify.vue?vue&type=script&lang=js"
export * from "./entry-add-classify.vue?vue&type=script&lang=js"
import style0 from "./entry-add-classify.vue?vue&type=style&index=0&id=3d245f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d245f2a",
  null
  
)

export default component.exports